import React from 'react';

// Last-resort fallback for the StatsConnect routes: a render error shows a
// plain recovery message instead of a blank page. Deliberately free of the
// connect modules (styles, copy) so it still renders when those fail to load.
const wrap = { minHeight: '60vh', background: '#070707', color: '#f4f5f1', padding: '96px 24px', fontFamily: 'Sora, sans-serif' };
const inner = { maxWidth: 640, margin: '0 auto' };
const link = { color: '#c4f82a' };

class ConnectErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.error('StatsConnect page failed to render', error);
  }

  render() {
    if (!this.state.failed) {
      return this.props.children;
    }
    return (
      <div style={wrap} role="alert" data-connect-fallback>
        <div style={inner}>
          <h1 style={{ fontSize: 32, lineHeight: 1.2, marginBottom: 16, color: '#f4f5f1' }}>Something went wrong on this page.</h1>
          <p style={{ color: '#a3a69a', marginBottom: 24 }}>
            Please reload it. If it keeps happening, write to{' '}
            <a style={link} href="mailto:marketing@smrtstats.com">
              marketing@smrtstats.com
            </a>
            .
          </p>
          <p>
            <a style={link} href="/connect">
              Back to StatsConnect
            </a>
          </p>
        </div>
      </div>
    );
  }
}

export default ConnectErrorBoundary;
